/** Backend SupportTicketCategory ile aynı. */
export enum SupportTicketCategory {
  TECHNICAL_ISSUE = 1,
  /** Talep sahibinin Daire Başkanı (merkez) / İşletme Müdürü (taşra) onayına gider. */
  TRAINEE_CHANGE = 2,
  OTHER = 3,
}

export const SUPPORT_TICKET_CATEGORIES: SupportTicketCategory[] = [
  SupportTicketCategory.TECHNICAL_ISSUE,
  SupportTicketCategory.TRAINEE_CHANGE,
  SupportTicketCategory.OTHER,
];

/** Backend SupportTicketApprovalStatus ile aynı. Onaya gitmeyen talepte null. */
export enum SupportTicketApprovalStatus {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
  CANCELLED = 3,
}

export const APPROVAL_STATUS_CHIP: Record<SupportTicketApprovalStatus, "warning" | "success" | "error" | "default"> = {
  [SupportTicketApprovalStatus.PENDING]: "warning",
  [SupportTicketApprovalStatus.APPROVED]: "success",
  [SupportTicketApprovalStatus.REJECTED]: "error",
  [SupportTicketApprovalStatus.CANCELLED]: "default",
};
